import { Button, Dialog, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ProjectConfig } from "Global";
import { ApiRequest } from "GlobalFunctions";

export default function ReasonsEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, reason_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    reason_id: reason_id ? reason_id : "null",
    reason: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (reason_id) {
      axios
        .get(`${ProjectConfig.api_url}/orders-concepts/details_reasons`, {
          params: { reason_id },
        })
        .then((response) => {
          setFormValues(response.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    } else {
      setFormValues(defaultValues);
    }
  }, [reason_id]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));

    await ApiRequest({
      url: "/orders-concepts/addedit_reasons",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: body,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Razón guardada con éxito", { variant: "success" });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: "502px" }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Razón</h2>
              <span className="h2_subtitle">{reason_id ? "Editar" : "Crear"}</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="reason"
              name="reason"
              label="Razón"
              type="text"
              required
              fullWidth
              value={formValues.reason}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
